<template>
  <v-dialog persistent v-model="alert" max-width="50%" >
    <v-card>
      <v-card-title :class="`title deep-purple white--text`">{{title}}</v-card-title>

      <v-card-text class="text-xs-center" v-html="text">
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#2F9AEE" flat="flat" @click="clickOk()">{{okText}}</v-btn>
        <!-- <v-btn color="deep-purple" flat="flat" @click="clickCancel()">{{cancelText}}</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'DialogBox',
  props: [
    
  ],
  data () {
    return {
      alert: false,
      title: '',
      text: '',
      okText:"ตกลง",
      cancelText:"ยกเลิก",
      resolve: null
    }
  },
  computed: {
  
  },
  methods: {
    clickOk() {
      this.resolve({status:"ok"})
      this.alert = false
    },
    clickCancel() {
      this.resolve({status:"cancel"})
      this.alert = false
    },
    show(text, typeAlertBox = null, title = null) {
      this.title = " " + title || ""
      this.text = text      
      this.alert = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
      })
    }
  }
}
</script>
